import angular from 'angular';
import booksMenu from '../../menu/Menu';

export default angular
  .module('finesReport', [booksMenu])
  .controller('finesReportController', finesReportController)
  .name;
  
/* @ngInject */ function finesReportController($scope, BooksSvc, SERVER, $q, BusyScreen, Session) {
  $scope.reportPage = Session.getSessionURL('/FinesReport.aspx');

  /*---------------------------------------------------------*/
  /* Static array of student options for "Students" dropdown */
  /*---------------------------------------------------------*/
  $scope.studentOptions = [
    { label: 'All', value: null, show: false },
    { label: 'Active Only', value: 1, show: false },
    { label: 'Inactive Only', value: -1, show: false },
    { label: 'Student Name', value: 0, show: true }
  ];

  /*----------------------------------*/
  /* Static array of grade selections */
  /*----------------------------------*/
  $scope.grades = [
    { label: 15, id: 15 },
    { label: 14, id: 14 },
    { label: 13, id: 13 },
    { label: 12, id: 12 },
    { label: 11, id: 11 },
    { label: 10, id: 10 },
    { label: 9, id: 9 },
    { label: 8, id: 8 },
    { label: 7, id: 7 },
    { label: 6, id: 6 },
    { label: 5, id: 5 },
    { label: 4, id: 4 },
    { label: 3, id: 3 },
    { label: 2, id: 2 },
    { label: 1, id: 1 },
    // The label must be a string for the select to work properly, otherwise it shows up as [Object object]
    { label: '0', id: 0 }
  ];

  /*---------------------*/
  /* Sets default values */
  /*---------------------*/
  $scope.req = { reportFormat: 'PDF', unpaidOnly: false };

  $scope.data = {
    student: null,
    grades: $scope.grades.map(function (grade) {
      return grade.id;
    })
  };

  /*-----------------------------------------------------------------*/
  /* Watches data.grades and converts array to string for submission */
  /*-----------------------------------------------------------------*/
  $scope.$watch('data.grades', function (grades) {
    $scope.req.grades = grades ? grades.toString() : '';
  });

  /*----------------------------------------------------------------*/
  /* Watches data.fines and converts array to string for submission */
  /*----------------------------------------------------------------*/
  $scope.$watch('data.fines', function (fine) {
    $scope.req.fineIDs = fine ? fine.toString() : '';
  });

  /*---------------------------------------------------------------------*/
  /* Watches the students dropdown selection and changes the             */
  /* data.student from null to 0 in req.active. This is done because the */
  /* "All" selection and the "Student name" selection both need to have  */
  /* a value of zero when submitted but we only want the student name    */
  /* typeahead to show when the students field is set to "Student name"  */
  /*---------------------------------------------------------------------*/
  $scope.$watch('data.student', function (student) {
    student == null
      ? ($scope.req.active = 0)
      : ($scope.req.active = student);
  });

  /*---------------------------------------------------------------*/
  /* Watches the data.entity model and makes the req.entityID 0 if */
  /* text entered in the typeahead does not match any student name */
  /*---------------------------------------------------------------*/
  $scope.$watch('data.entity', function (entity) {
    if (!angular.isNumber(entity)) {
      $scope.req.entityID = 0;
    } else {
      $scope.req.entityID = entity;
    }
  });

  /*-------------------------------------------------*/
  /* Formats the fullName and the studentID together */
  /* to be displayed in the student name typeahead.  */
  /*-------------------------------------------------*/
  $scope.studentLabelFunction = function (student) {
    return (
      student.fullName +
      (student.studentID ? ' (' + student.studentID + ')' : '')
    );
  };

  /*****************************************************************************
   * formatName */
  /**
   * Returns the corresponding student names from the getStudentNames() to display
   * in the typeahead.
   * When no match is found will retun empty string.
   *
   * @param  model  Current model value
   * @return        Corresponding item.
   *****************************************************************************/
  $scope.formatName = function (model) {
    if ($scope.students)
      for (var i = 0; i < $scope.students.length; i++) {
        if ($scope.students[i].id == model) {
          return (
            $scope.students[i].name +
            ($scope.students[i].studentID
              ? ' (' + $scope.students[i].studentID + ')'
              : '')
          );
        }
      }
    return '';
  };

  /*-----------------*/
  /* Date validation */
  /*-----------------*/
  $scope.valOption = {};
  $scope.validateInput = function () {
    return $scope.valOption.validate();
  };

  /*-------------------*/
  /* Load initial data */
  /*-------------------*/
  BooksSvc.getOrganization().then(function (resp) {
    $scope.org = resp.data;

    BooksSvc.getItemList(SERVER.BooksDBConstants.IT_FINES).then(
      function (resp) {
        resp.data.sort(function (a, b) {
          return a.shortDescription
            .toLowerCase()
            .localeCompare(b.shortDescription.toLowerCase());
        });
        $scope.fines = resp.data;
        $scope.data.fines = $scope.fines.map(function (fine) {
          return fine.id;
        });

        $scope.getStudentNames = function (text) {
          var defer = $q.defer();
          BooksSvc.findEntities(
            text,
            SERVER.BooksDBConstants.ET_STUDENT
          ).then(function (resp) {
            $scope.students = resp.data;
            defer.resolve($scope.students);
          });
          return defer.promise;
        };
        BusyScreen.setBusy(false);
      }
    );
  });
}